import React, {Component} from 'react';
import {Switch, Route} from 'react-router-dom';
import {connect} from 'react-redux';

import Header from 'header';
import Sidebar from 'components/sidebar';
import Footer from 'components/footer';
import Mailing from './mailing';
import CreateMail from './mailing/create';
import MailDetail from './mailing/detail';
import {Content, ContentInner} from 'components/content';
import {routes} from './routes';

import {loadUser} from 'redux/actions/auth';

const mapStateToProps = state => ({
  token: state.auth.get('token'),
  user: state.auth.get('user')
})

const mapDispatchToProps = dispatch => ({
  onLoad: () => dispatch(loadUser())
})

class OperatorRouter extends Component {

  componentWillMount() {
    if (this.props.token) {
      this.props.onLoad();
    }
  }

  render() {

    if (this.props.user === undefined) return null;

    return (
      <div>
       <Header/>
       <Content>
         <Sidebar routes={routes} cabinet="Кабінет оператора"/>
         <ContentInner>
           <Switch>
             <Route exact path="/operator/" component={Mailing} />
             <Route exact path="/operator/mailing" component={Mailing} />
             <Route exact path="/operator/mailing/detail/:mail_id" component={MailDetail} />
             <Route exact path="/operator/mailing/detail/:mail_id/edit" component={CreateMail} />
             <Route exact path="/operator/mailing/create/:document_id" component={CreateMail} />
             <Route exact path="/operator/mailing/:page" component={Mailing} />
           </Switch>
         </ContentInner>
       </Content>
       <Footer/>
     </div>
    )
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(OperatorRouter);



// WEBPACK FOOTER //
// ./src/operator/index.js